import { gerarProcuracaoPDF, validarDados } from '../utils/pdfGenerator';

export const procuracaoService = {
    /**
     * Gera PDF de procuração localmente no navegador
     * @param {Object} dados - Dados da procuração
     * @returns {Promise} Response com blob do PDF
     */
    gerarPDF: async (dados) => {
        try {
            // Validar dados
            const erros = validarDados(dados);
            if (erros.length > 0) {
                const error = new Error(erros[0]);
                error.response = { 
                    data: { 
                        message: erros.join('; '),
                        valido: false 
                    } 
                };
                throw error;
            }

            // Gerar PDF localmente
            const blob = await gerarProcuracaoPDF(dados);
            
            // Retornar no mesmo formato do axios para compatibilidade
            return {
                data: blob,
                status: 200,
                statusText: 'OK',
                headers: { 'content-type': 'application/pdf' }
            };
        } catch (error) {
            throw error;
        }
    },

    /**
     * Valida dados da procuração (client-side)
     * @param {Object} dados - Dados da procuração
     * @returns {Promise} Resultado da validação
     */
    validar: async (dados) => {
        try {
            const erros = validarDados(dados);
            return {
                valido: erros.length === 0,
                erros: erros,
                erro: erros.length > 0 ? erros[0] : null
            };
        } catch (error) {
            throw error;
        }
    }
};

export default procuracaoService;
